import { getAddress } from './getAddress';
import { getTelecom } from './getTelecom';

export const getContactDetails = (
  addressXml: Document | Array<Document>,
  telecomXml: Document | Array<Document>,
): string => {
  const address = getAddress(addressXml);
  const telecom = getTelecom(telecomXml);

  return `${address || ''}${address && telecom ? '\n' : ''}${telecom || ''}`;
};
